/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccPatientAddress } from './PccPatientAddress';
import {
    PccPatientAddressFromJSON,
    PccPatientAddressToJSON,
} from './PccPatientAddress';
/**
 * 
 * @export
 * @interface PccPatientResponse
 */
export interface PccPatientResponse {
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    orgUuid?: string;
    /**
     * 
     * @type {number}
     * @memberof PccPatientResponse
     */
    facId?: number;
    /**
     * 
     * @type {number}
     * @memberof PccPatientResponse
     */
    patientId?: number;
    /**
     * 
     * @type {number}
     * @memberof PccPatientResponse
     */
    patientStatus?: number;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    prefix?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    homePhone?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    cellPhone?: string;
    /**
     * 
     * @type {Array<{languageDesc?: string}>}
     * @memberof PccPatientResponse
     */
    language?: Array<{languageDesc?: string}>;
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponse
     */
    maritalStatus?: string;
    /**
     * 
     * @type {Array<{raceDesc?: string}>}
     * @memberof PccPatientResponse
     */
    race?: Array<{raceDesc?: string}>;
    /**
     * 
     * @type {PccPatientAddress}
     * @memberof PccPatientResponse
     */
    previousAddress?: PccPatientAddress;
}

/**
 * Check if a given object implements the PccPatientResponse interface.
 */
export function instanceOfPccPatientResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccPatientResponseFromJSON(json: any): PccPatientResponse {
    return PccPatientResponseFromJSONTyped(json, false);
}

export function PccPatientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orgUuid': !exists(json, 'orgUuid') ? undefined : json['orgUuid'],
        'facId': !exists(json, 'facId') ? undefined : json['facId'],
        'patientId': !exists(json, 'patientId') ? undefined : json['patientId'],
        'patientStatus': !exists(json, 'patientStatus') ? undefined : json['patientStatus'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'birthDate': !exists(json, 'birthDate') ? undefined : json['birthDate'],
        'prefix': !exists(json, 'prefix') ? undefined : json['prefix'],
        'suffix': !exists(json, 'suffix') ? undefined : json['suffix'],
        'homePhone': !exists(json, 'homePhone') ? undefined : json['homePhone'],
        'cellPhone': !exists(json, 'cellPhone') ? undefined : json['cellPhone'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'maritalStatus': !exists(json, 'maritalStatus') ? undefined : json['maritalStatus'],
        'race': !exists(json, 'patientRaces') ? undefined : json['patientRaces'],
        'previousAddress': !exists(json, 'previousAddress') ? undefined : PccPatientAddressFromJSON(json['previousAddress']),
    };
}

export function PccPatientResponseToJSON(value?: PccPatientResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orgUuid': value.orgUuid,
        'facId': value.facId,
        'patientId': value.patientId,
        'patientStatus': value.patientStatus,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'middleName': value.middleName,
        'gender': value.gender,
        'birthDate': value.birthDate,
        'prefix': value.prefix,
        'suffix': value.suffix,
        'homePhone': value.homePhone,
        'cellPhone': value.cellPhone,
        'language': value.language,
        'maritalStatus': value.maritalStatus,
        'patientRaces': value.race,
        'previousAddress': PccPatientAddressToJSON(value.previousAddress),
    };
}

